import { Context, Controller } from '@hotwired/stimulus';

export default class BulkSelectController extends Controller {
  static targets = ['toggleAll', 'item'];

  private declare readonly toggleAllTarget: HTMLInputElement;
  private declare readonly itemTargets: HTMLInputElement[];

  constructor(context: Context) {
    super(context);
  }

  public toggleAll(): void {
    const isChecked = this.toggleAllTarget.checked;

    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
  }

  public updateToggleAll(): void {
    const totalItems = this.itemTargets.length;
    const checkedItems = this.itemTargets.filter((cb) => cb.checked).length;

    if (checkedItems === 0) {
      // None checked
      this.toggleAllTarget.checked = false;
      this.toggleAllTarget.indeterminate = false;
    } else if (checkedItems === totalItems) {
      // All checked
      this.toggleAllTarget.checked = true;
      this.toggleAllTarget.indeterminate = false;
    } else {
      // Some checked
      this.toggleAllTarget.checked = false;
      this.toggleAllTarget.indeterminate = true;
    }
  }
}
